export default {"src":"/_next/static/media/skiën.0c6f6377.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};